import { Directive, InputSignal, OnDestroy, inject, input } from '@angular/core';
import { AutoComplete } from 'primeng/autocomplete';
import { Subscription } from 'rxjs';

@Directive({
  standalone: true,
  selector: 'p-autoComplete, p-autocomplete'
})
export class AutocompleteLabelDirective implements OnDestroy {
  field: InputSignal<string | undefined> = input();
  label: InputSignal<string | undefined> = input();
  optionLabel: InputSignal<string | ((item: any) => string) | undefined> = input();
  suggestions: InputSignal<any[] | undefined> = input();
  updateTimer = 50;

  readonly autoComplete = inject(AutoComplete, { optional: true });

  private sub$?: Subscription;

  private setInputLabel() {
    const autoComplete = this.autoComplete;
    const inputEl = autoComplete?.inputEL?.nativeElement;
    if (!autoComplete || !inputEl) {
      return;
    }

    const optionLabel = this.optionLabel();
    const selectedValue = autoComplete.value;

    if (typeof optionLabel === 'function') {
      inputEl.value = optionLabel(selectedValue);
      return;
    }

    if (typeof optionLabel === 'string' && selectedValue && typeof selectedValue === 'object') {
      const rawValue = (selectedValue as Record<string, unknown>)[optionLabel];
      inputEl.value = rawValue != null ? String(rawValue) : '';
      return;
    }

    inputEl.value = selectedValue != null ? String(selectedValue) : '';
  }

  constructor() {
    if (this.autoComplete && this.autoComplete.multiple !== true) {
      this.sub$ = this.autoComplete.onSelect.subscribe((_item) => {
        setTimeout(() => {
          this.setInputLabel();
        }, this.updateTimer);
      });
    }
  }

  ngAfterViewInit(): void {
    // Set the input value on initial load if a value exists
    setTimeout(() => {
      this.setInputLabel();
    }, this.updateTimer);
  }

  ngOnDestroy(): void {
    this.sub$?.unsubscribe();
  }
}
